
    <!-- <div class="container">
      <h1 class="text-center" id="page-title">Making cards...</h1>
      <div class="row" id="portfolio">
        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
          <div class="card" id="storageCard">
            <div class="card-title">Used space</div>
            <div class="card-icon"><i class="fa fa-search"></i></div>
            <div class="card-data">99/100 GB</div>
            <hr/>
            <div class="card-hint"> <i class="fa fa-start"></i><a href="#">Get more space</a></div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
          <div class="card" id="loveCard">
            <div class="card-title">Amount received</div>
            <div class="card-icon"><i class="fa fa-file-detail-o"></i></div>
            <div class="card-data">101%</div>
            <hr/>
            <div class="card-hint"> <i class="fa fa-search-close"></i><a href="#">Share the love ASAP =)</a></div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
          <div class="card" id="pizzaCard">
            <div class="card-title">Pizza eaten</div>
            <div class="card-icon"><i class="fa fa-send"></i></div>
            <div class="card-data">12 pcs</div>
            <hr/>
            <div class="card-hint"> <i class="fa fa-share-o"></i><a href="#">Drink some Cola</a></div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-3">
          <div class="card" id="gameCard">
            <div class="card-title">Games played</div>
            <div class="card-icon"><i class="fa fa-shopping-bag"></i></div>
            <div class="card-data">1800+ hours</div>
            <hr/>
            <div class="card-hint"> <i class="fa fa-search"></i><a href="#">You better learn to code</a></div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="dashboard-container">
        <div class="row">
            <div class="col-md-4 col-xl-4">
                <div class="card bg-c-blue order-card">
                    <div class="card-block">
                        <h6 class="m-b-20">Project Schedule</h6>
                        <h2 class="text-right"><i class="fa fa-credit-card f-left"></i><span>{{totalDays}} Days</span></h2>
                        <p class="m-b-0">Completed Days<span class="f-right">{{completedDays}}</span></p>
                        <p class="m-b-0">Remaining Days<span class="f-right">{{remainingDays}}</span></p>
                        <p class="m-b-0">Overdue Days<span class="f-right">{{overDueDays}}</span></p>

                    </div>
                </div>
            </div>

            <div class="col-md-4 col-xl-4">
                <div class="card bg-c-green order-card">
                    <div class="card-block">
                        <h6 class="m-b-20">Schedule Documents</h6>
                        <h2 class="text-right"><i class="fa fa-clone f-left"></i><span>{{plannedDocuments}}</span></h2>
                        <p class="m-b-0">Completed Documents<span class="f-right">{{completedDocuments}}</span></p>
                        <p class="m-b-0">Remaining Documents<span class="f-right">{{balanceDocuments}}</span></p>

                    </div>
                </div>
            </div>

            <div class="col-md-4 col-xl-4">
                <div class="card bg-c-yellow order-card">
                    <div class="card-block">
                        <h6 class="m-b-20">Schedule Document Man Hours</h6>
                        <h2 class="text-right"><i class="fa fa-clone f-left"></i><span>{{plannedManHours}}</span></h2>
                        <p class="m-b-0">Actual Man Hours<span class="f-right">{{actualManHours}}</span></p>
                        <p class="m-b-0">Remaining Man Hours<span class="f-right">{{balanceManHours}}</span></p>

                    </div>
                </div>
            </div>

            <!-- <div class="col-md-4 col-xl-3">
                <div class="card bg-c-pink order-card">
                    <div class="card-block">
                        <h6 class="m-b-20">Communication</h6>
                        <h2 class="text-right"><i class="fa fa-credit-card f-left"></i><span>{{Inbox_Count + Sent_Count}}</span></h2>
                        <p class="m-b-0">Inbox<span class="f-right">{{Inbox_Count}}</span></p>
                        <p class="m-b-0">Sent<span class="f-right">{{Sent_Count}}</span></p>
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-md-4 col-xl-2">
                <div class="card bg-c-green1 order-card">
                    <div class="card-block">
                        <h6 class="m-b-20">Orders Received</h6>
                        <h2 class="text-right"><i class="fa fa-credit-card f-left"></i><span>486</span></h2>
                        <p class="m-b-0">Completed Orders<span class="f-right">351</span></p>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-xl-2">
                <div class="card bg-c-purple order-card">
                    <div class="card-block">
                        <h6 class="m-b-20">Orders Received</h6>
                        <h2 class="text-right"><i class="fa fa-credit-card f-left"></i><span>486</span></h2>
                        <p class="m-b-0">Completed Orders<span class="f-right">351</span></p>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="row row-10 eip-mt-20">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="eip-panel-body eip-pxy-10">

                    <div  class="eip-panel-header"><p class="fs-16 ff-3">Project Schedule</p></div>

                    <div class="eip-pt-0">
                        <kendo-chart [transitions]="true">
                            <kendo-chart-title text="Project Schedule" color="white"></kendo-chart-title>
                            <kendo-chart-series>
                                <kendo-chart-series-item type="pie"  [data]="projectDetails" field="doc_Count"
                                    categoryField="status" colorField="color" [autoFit]="false">
                                    <kendo-chart-series-item-labels  [align]="center"
                                    color="#000"
                                    [content]="labelContent">
                                    </kendo-chart-series-item-labels>
                                </kendo-chart-series-item>
                            </kendo-chart-series>
                            <kendo-chart-tooltip>
                                <ng-template kendoChartSeriesTooltipTemplate let-category="category" let-dataItem="dataItem">
                                    {{ category }} -  {{ dataItem.doc_Percentage }} %
                                </ng-template>
                            </kendo-chart-tooltip>
                            <kendo-chart-legend position="bottom" [visible]="true"></kendo-chart-legend>
                        </kendo-chart>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="eip-panel-body eip-pxy-10">

                    <div  class="eip-panel-header"><p class="fs-16 ff-3">Schedule Documents</p></div>

                    <div>
                        <kendo-chart  *ngIf="scheduleCount >0">
                            <!-- <kendo-chart-title text="Engineering Schedule Document Status"></kendo-chart-title> -->
                            <kendo-chart-series>
                                <kendo-chart-series-item type="column" [data]="projectScheduleDetails" field="doc_Count"
                                    categoryField="status" colorField="color" [dynamicHeight]="dynamicHeight" [gap]="1" [spacing]="1">
                                    <kendo-chart-series-item-labels background="none" color="white" format="N0">
                                    </kendo-chart-series-item-labels>
                                </kendo-chart-series-item>
                            </kendo-chart-series>
                            <kendo-chart-tooltip>
                                <ng-template kendoChartSeriesTooltipTemplate let-category="category" let-dataItem="dataItem">
                                    {{ category }} -  {{ dataItem.doc_Percentage }} %
                                </ng-template>
                            </kendo-chart-tooltip>
                            <kendo-chart-legend position="bottom" [title]="legendTitle" [visible]="true"></kendo-chart-legend>
                        </kendo-chart>
                    </div>
                </div>
            </div>
           
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="eip-panel-body eip-pxy-10">

                    <div  class="eip-panel-header"><p class="fs-16 ff-3">Schedule Document Man Hours</p></div>
                    <div>

                        <kendo-chart *ngIf="scheduleMHCount >0">
                            <!-- <kendo-chart-title text="Communication"></kendo-chart-title> -->
                            <kendo-chart-series>
                                <kendo-chart-series-item type="donut" [data]="projectDocScheduleMHDetails1" field="doc_Count"
                                    categoryField="status" colorField="color" [dynamicHeight]="dynamicHeight">
                                    <kendo-chart-series-item-labels background="none" color="white" format="N0">
                                    </kendo-chart-series-item-labels>
                                </kendo-chart-series-item>
                            </kendo-chart-series>
                            <kendo-chart-tooltip>
                                <ng-template kendoChartSeriesTooltipTemplate let-category="category" let-dataItem="dataItem">
                                    {{ category }} -  {{ dataItem.doc_Percentage }} %
                                </ng-template>
                            </kendo-chart-tooltip>
                            <kendo-chart-legend position="bottom" [visible]="true"></kendo-chart-legend>
                        </kendo-chart>
                    </div>
                </div>
            </div>

        </div>